export enum ApiWorkplaceStateCode {
    Idle = 'idle',
    Work = 'work',
    Repair = 'repair',
    Adjustment = 'adjustment',
    Maintenance = 'maintenance',
}

export type MachineToolState = {
    code: ApiWorkplaceStateCode,
    name: string,
}

export const WorkplaceStateSpec: { [key in ApiWorkplaceStateCode]: Omit<MachineToolState, 'code'> } = {
    [ApiWorkplaceStateCode.Idle]: { name: 'Простой' },
    [ApiWorkplaceStateCode.Work]: { name: 'В работе' },
    [ApiWorkplaceStateCode.Repair]: { name: 'Ремонт' },
    [ApiWorkplaceStateCode.Maintenance]: { name: 'ТО' },
    [ApiWorkplaceStateCode.Adjustment]: { name: 'Наладка' },
}


export const WorkplaceStateList: MachineToolState[] = Object.keys(WorkplaceStateSpec).map(code => ({
    ...WorkplaceStateSpec[code as keyof typeof WorkplaceStateSpec],
    code: code as ApiWorkplaceStateCode,
}));
